import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ShareWeb = createSvgIcon(
  <path d="M10.5 7.5A10.092 10.092 0 0 0 .435 16.85L0 22.75l3.998-3.702A9.568 9.568 0 0 1 10.5 16.5v6L24 12 10.5 1.5v6Zm2.25-1.4 7.585 5.9-7.585 5.9v-3.65H10.5a11.82 11.82 0 0 0-7.836 2.97l.015-.205A7.842 7.842 0 0 1 10.5 9.75h2.25V6.1Z" />,
  'ShareWeb'
);

export { ShareWeb };